module.exports = __webpack_public_path__ + "img/red_075.45500ad2.png";